import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'lib-brand-logo',
  templateUrl: './brand-logo.component.html',
  styleUrls: ['./brand-logo.component.scss'],
  imports: [NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandLogoComponent {
  textColor = input<'LIGHT' | 'DARK'>('LIGHT');
  showText = input(true);

  protected logoPath = computed(() => {
    if (!this.showText()) {
      return 'https://app.design-tokens.io/assets/logo_logo_only_light.png';
    }
    return this.textColor() === 'LIGHT'
      ? 'https://app.design-tokens.io/assets/logo_full_light.png'
      : 'https://app.design-tokens.io/assets/logo_full_dark_2.png';
  });
}
